// extracted by mini-css-extract-plugin
export var accordion = "_be-0";
export var chevron = "_be-3";
export var closed = "_be-2";
export var content = "_be-4";
export var open = "_be-1";
export var rotate = "_be-5";